export default __webpack_public_path__ + "static/media/error.009ee940.svg";